import * as React from 'react'
import { PanelSummaryHeader } from '@components/panels/PanelSummaryHeader'
import { Panel } from '@components/panels/panels'
import styled from 'styled-components'

interface Props {
  recentActions: any
}

const EmptyActionsContainer = styled.div`
  padding: 24px 16px;
  text-align: center;
`

const EmptyTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.textSecondary || '#9CA6AD'};
  margin-bottom: 6px;
`

const EmptyHint = styled.div`
  font-size: 13px;
  color: ${props => props.theme.textDisabled || '#6B7680'};
  line-height: 1.4;
`

export const RecentActions = (props: Props) => {
  const { recentActions } = props
  return (
    <Panel>
      <PanelSummaryHeader title="Actions" disabled={true} path="" args={{}} />
      <table>
        <tbody>
          {recentActions.length > 0 &&
            recentActions.map((v: any, k: any) => {
              return (
                <tr key={k}>
                  <td>{v.action}</td>
                  <td>{v.actionTime}</td>
                </tr>
              )
            })}
        </tbody>
      </table>
      {recentActions.length === 0 && (
        <EmptyActionsContainer>
          <EmptyTitle>No recent activity</EmptyTitle>
          <EmptyHint>
            Actions like adding shareholders, issuing shares, and transfers will appear here.
          </EmptyHint>
        </EmptyActionsContainer>
      )}
    </Panel>
  )
}
